import React from 'react';
import blueArrow from '../../assets/images/blue_left_arrow.svg';
import rightarrow from "../../assets/images/right-arrow.svg";

// Spinner Component
const Spinner = () => (
    <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
);

interface ButtonProps {
    onClick?: () => void;
    label: React.ReactNode;
    className?: string;
    type: 'button' | 'submit' | 'reset';
    icon?: React.ReactNode;
    iconPosition?: 'start' | 'end';
    variant: 'primary' | 'secondary';
    loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
    onClick,
    label,
    className,
    type,
    icon,
    iconPosition,
    variant,
    loading = false
}) => {
    return (
        <>
            {variant === 'primary' ? (
                <button
                    type={type}
                    onClick={onClick}
                    className={`w-max mb-4 text-white bg-pink-600 hover:bg-pink-800 focus:ring-4 shadow-md rounded-3xl items-center focus:outline-none focus:ring-white-300 font-medium pl-4 md:pl-6 pr-3 md:pr-4 py-2 md:py-2.5 text-center inline-flex text-[12px] md:text-sm ${className} ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={loading}
                >
                    {iconPosition === 'start' && icon && icon}
                    {loading && <Spinner />} {/* Spinner next to the label */}
                    {label}

                    {iconPosition === 'end' && icon && icon}
                    <img className="right-arrow" src={rightarrow} alt="arrow" />
                </button>
            ) : (
                <button
                    type={type}
                    onClick={onClick}
                    className={`font-roboto text-sm font-medium text-indigo-600 gap-1 py-2.5 text-center flex items-center justify-evenly ${className} ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={loading}
                >
                    <img className='mr-3' src={blueArrow} alt='icon' />
                    {iconPosition === 'start' && icon && icon}
                    {label}
                    {loading && <Spinner />}
                    {iconPosition === 'end' && icon && icon}
                </button>
            )}
        </>
    );
};

export default Button;
